<!--  -->
<template>
  <div>
    <div class="leftInfo">
        
    </div>
    <div class="detailInfo">

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  mounted: {},

  methods: {}
}

</script>
<style scoped>
</style>